import Box from '@mui/material/Box';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import { useMediaThumbUrl } from '../media/useMediaBlobUrl';

/** Width of the preview strip, in px; its height is the card header's. */
const PREVIEW_WIDTH = 96;

/**
 * The picture at the right edge of a field list card, as tall as the card's
 * header — the header's text decides the height, the picture only fills it.
 * Plain strings as props, so the card's `memo` holds; the thumbnail is fetched
 * only while the card is on screen (the list is virtualised).
 */
export default function FieldCardPreview({
    mediaId,
    version
}: {
    mediaId: string;
    /** The media doc's `updatedAt` — see `useMediaThumbUrl`. */
    version: string;
}) {
    const { url, loading } = useMediaThumbUrl(mediaId, version);
    return (
        <Box
            sx={{
                position: 'relative',
                width: PREVIEW_WIDTH,
                flexShrink: 0,
                alignSelf: 'stretch',
                bgcolor: 'action.hover',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            {url ? (
                // Absolute, so the picture fills the header instead of
                // stretching it to its own aspect ratio.
                <Box
                    component="img"
                    src={url}
                    alt=""
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        width: 1,
                        height: 1,
                        objectFit: 'cover'
                    }}
                />
            ) : (
                !loading && <BrokenImageIcon color="disabled" />
            )}
        </Box>
    );
}
